<template>
  <div class="text-with-badge">
    <slot />
    <e-tooltip max-width="364px">
      <template #activator>
        <div class="text-with-badge__badge with-badge" />
      </template>

      <slot name="tooltip" />
    </e-tooltip>
  </div>
</template>

<script setup lang="ts">
import { ETooltip } from '@/core/components/ui';

defineSlots<{
  default: () => void;
  tooltip: () => void;
}>();
</script>

<style scoped lang="scss">
.text-with-badge {
  display: flex;
  align-items: center;

  &__badge {
    position: relative;
    bottom: 0.5em;

    height: 8px;
  }
}
</style>
